<template>
  <div class="selector">
    <div class="selector-headers">
      <li :class="{
        'selector-selected-item':selected.header===item
      }" v-for="(item, index) in headers" :key="index" class="selector-header-item" @click="onHeaderClick(item)">
        {{item}}
      </li>
      <div class="clearfix"></div>
    </div>
    <div class="selector-items">
      <li v-for="(item, index) in items" :key="index" class="selector-item" @click="onSelected(item)">
        {{item.name}}
      </li>
      <div class="clearfix"></div>
    </div>
    <div class="selector-items">
      <li v-for="(item, index) in all" :key="index" class="selector-item" @click="onSelected(item)">
        {{item.name}}
      </li>
      <div class="clearfix"></div>
    </div>
    <div class="select-form">
      <div  class="form-horizontal">
        <price-form :price="price"></price-form>
        <div class="form-group">
          <div class="col-sm-10 col-sm-offset-2">
            <button class="btn btn-default" @click="addPrice">添加</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as TYPES from '../../store/types'
import PriceForm from '@/components/forms/Price'
export default {
  components: {
    PriceForm
  },
  data() {
    return {
      price: {
        category: {},
        name: '',
        priceString: ''
      },
      selected: {
        header: '',
        item: {}
      }
    }
  },
  computed: {
    headers() {
      return this.$store.state.prices.selector.headers
    },
    items() {
      return this.$store.state.prices.selector.items
    },
    all() {
      return this.$store.state.prices.all
    }
  },
  created() {
    this.$store.dispatch(TYPES.DO_GET_PRICES_SELECTOR_HEADERS)
    this.$store.dispatch(TYPES.DO_GET_ALL_PRICES)
  },
  methods: {
    onHeaderClick(item) {
      this.$store
        .dispatch(TYPES.DO_GET_PRICES_BY_SEARCH_SELECTOR_HEADER, item)
        .then(res => {
          this.selected.header = item
        })
    },
    onSelected(item) {
      this.$emit('onSelected', item)
    },
    addPrice() {
      this.price.category.text = this.selected.header
      this.$store.dispatch(TYPES.DO_ADD_CLOTHE_PRICE, Object.assign(this.price))
      .then(res => {
        this.$notify({
          type: 'success',
          content: '成功添加衣物!'
        })
        this.price = {
          category: {},
          name: '',
          priceString: ''
        }
        this.onHeaderClick(this.selected.header)
      })
      .catch(res => {
        console.log(res)
        this.$notify({
          type: 'danger',
          content: res.data.msg
        })
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/selectors/Price.vue